module.exports = __webpack_public_path__ + "img/122.10.b3c4d850.png";